import { computed, type Ref } from 'vue';
import { isDirectoryTitleValid } from '../config/directoryTitle';

export interface CreateFolderSubmitPayload {
  name: string;
}

export function useCreateFolderForm(title: Ref<string>) {
  const trimmedTitle = computed(() => title.value.trim());

  const isTitleValid = computed(() => isDirectoryTitleValid(title.value));

  const reset = () => {
    title.value = '';
  };

  const buildSubmitPayload = (): CreateFolderSubmitPayload => ({
    name: trimmedTitle.value,
  });

  return {
    trimmedTitle,
    isTitleValid,
    reset,
    buildSubmitPayload,
  };
}
